import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";

import BottomMessagePopUp from "../../components/BottomMessagePopUp";
import FloatLabelInput from "../../components/FloatingLabel";
import FloatingTextarea from "../../components/FloatingTextArea";

import submitSuccessFul from "../../assets/images/submit-successful.png";
import submitFail from "../../assets/images/submit-failed.png";

import phoneIcon from "../../assets/images/phone-icon.png";
import emailIcon from "../../assets/images/email-icon.png";
import { Image } from "primereact/image";
import useGetToken from "../../store/selectors/get-token";
import { submitHelp } from "../../utils/backend";
import useStoreToken from "../../store/actions/store-token";
import { Dialog } from "primereact/dialog";
import { useTranslation } from 'react-i18next';

const AnsaHelp = () => {
	const { t } = useTranslation();
	const [email, setEmail] = useState("");
	const [image, setImage] = useState(submitSuccessFul);
	const [dialogTitle, setDialogTitle] = useState(t(`ansaHelp.submitted.title`));
	const [respMessage, setRespMessage] = useState(t(`ansaHelp.submitted.subTitle`));
	const [dialogOpen, setDialogOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const storeToken = useStoreToken();
	const token = useGetToken();

	useEffect(() => {
		const queryParameters = new URLSearchParams(window.location.search);
		const tokenParam = queryParameters.get("token");
		storeToken(tokenParam);
	}, []);

	const handleCloseButton = (e) => {
		e.preventDefault();
		setDialogOpen(false);
	};

	const handleBackButton = (e) => {
		e.preventDefault();
		window.ReactNativeWebView.postMessage('closeWebView');
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			setLoading(true);

			const payloads = {
				email,
				message,
			};

			const response = await submitHelp(token, payloads);

			if (response.success) {
				setImage(submitSuccessFul);
				setDialogTitle(t(`ansaHelp.submitted.title`));
				setRespMessage(t(`ansaHelp.submitted.subTitle`));
				setDialogOpen(true);
			} else {
				setImage(submitFail);
				setDialogTitle(t(`ansaHelp.unableToSubmit.title`));
				setRespMessage(t(`ansaHelp.unableToSubmit.subTitle`));
				setDialogOpen(true);
			}
		} catch (error) {
			showErrorMessage(error.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<div className="content">
				<div className="get-quote-container d-m-column">
					{/* Right Section */}
					<div className="get-quote-form-section w-100">
						<div className="d-flex flex-row justify-content-between w-100 mt-10">
							<div className="w-70 text-left">
								<h4 className="mt-0 mb-0">{t(`ansaHelp.title`)}</h4>
							</div>
							<p className="formatted-text">{t(`ansaHelp.subTitle`)}</p>
						</div>

						<form className="form-input-get-quote w-100">
							<div className="form-input-get-quote-group">
								<div className="input-group">
									<FloatLabelInput
										label={t(`common.emailAddress`)}
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										placeholder=""
									/>
								</div>
							</div>

							<div className="form-input-get-quote-group">
								<div className="input-group">
									<FloatingTextarea
										label={t(`common.message`)}
										value={message}
										onChange={(e) => setMessage(e.target.value)}
										placeholder=""
										rows="4"
									/>
								</div>
							</div>
						</form>

						<div className="d-flex flex-column justify-content-between w-100 mt-10">
							<div className="text-left">
								<h4 className="mt-0 mb-0">{t(`ansaHelp.operationTime`)}</h4>
							</div>
							<p className="formatted-text">{t(`ansaHelp.happyToHelpYou`)}</p>

							<div className="d-flex align-items-center w-100 mt-2">
								<Image
									className="mr-2"
									src={phoneIcon}
									height={36}
									width={36}
								/>
								<span className="text-justify w-85">
									<Link
										className="fw-bold color-primary"
										to=""
									>{`012 3569 910`}</Link>
								</span>
							</div>

							<div className="d-flex align-items-center w-100 mt-2">
								<Image
									className="mr-2"
									src={emailIcon}
									height={36}
									width={36}
								/>
								<span className="text-justify w-85">
									<Link
										className="fw-bold color-primary"
										to=""
									>{`support@ansa.com.my`}</Link>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="btn-footer pb-4">
					<Button
						label={t(`ansaHelp.submitEmail`)}
						className="btn-primary"
						loading={loading}
						onClick={handleSubmit}
						size="large"
					/>
				</div>

				<Dialog
					className="filter-modal d-flex flex-row bg-white p-4 gap-2"
					modal
					header={`Filters`}
					visible={dialogOpen}
					style={{
						borderRadius: "24px 24px 0 0",
						margin: 0,
						width: "100vw",
						overflowY: "auto",
					}}
					position={"bottom"}
					content={({ hide }) => (
						<>
							<div className="filters d-flex justify-content-center w-100">
								<Image
									className="mr-2"
									src={image}
									height={80}
									width={80}
								/>
								<div className="d-flex flex-row justify-content-center mb-4">
									<h2 className="">{dialogTitle}</h2>
									<span className="formatted-text text-center">{respMessage}</span>
								</div>
							</div>
							<Button
								className="btn-primary fw-bold"
								label={t(`common.close`)}
								onClick={(e) => handleCloseButton(e)}
							/>
							<Button
								className="btn-secondary fw-bold"
								label={t(`ansaHelp.backToHome`)}
								onClick={(e) => handleBackButton(e)}
							/>
						</>
					)}
				></Dialog>
				{/* BottomMessagePopUp Component */}
				<BottomMessagePopUp
					message={errorMessage}
					type="error"
					isVisible={isErrorVisible}
					onClose={() => setIsErrorVisible(false)}
				/>
			</div>
		</>
	);
};

export default AnsaHelp;
